import { get, postJson, post } from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let cfPlanApi = {}

// ==================== 出房付款计划 ====================

/**
 * 单个插入出房付款计划
 */
cfPlanApi.insertPlan = function (params) {
    return postJson('/cfplan/plan/insert', params)
}

/**
 * 批量插入出房付款计划
 */
cfPlanApi.insertPlanBatch = function (params) {
    return postJson('/cfplan/plan/insertBatch', params)
}

/**
 * 修改出房付款计划
 */
cfPlanApi.updatePlan = function (params) {
    return postJson('/cfplan/plan/update', params)
}

/**
 * 删除出房付款计划
 */
cfPlanApi.deletePlan = function (params) {
    return postJson('/cfplan/plan/delete', params)
}

/**
 * 查询出房付款计划
 */
cfPlanApi.selectPlan = function (params) {
    return postJson('/cfplan/plan/select', params)
}

// ==================== 出房付款明细 ====================

/**
 * 单个插入出房付款明细
 */
cfPlanApi.insertDetail = function (params) {
    return postJson('/cfplan/detail/insert', params)
}

/**
 * 批量插入出房付款明细
 */
cfPlanApi.insertDetailBatch = function (params) {
    return postJson('/cfplan/detail/insertBatch', params)
}

/**
 * 修改出房付款明细
 */
cfPlanApi.updateDetail = function (params) {
    return postJson('/cfplan/detail/update', params)
}

/**
 * 删除出房付款明细
 */
cfPlanApi.deleteDetail = function (params) {
    return postJson('/cfplan/detail/delete', params)
}

/**
 * 查询出房付款明细
 */
cfPlanApi.selectDetail = function (params) {
    return postJson('/cfplan/detail/select', params)
}

cfPlanApi.invalidatePlan = function (params) {
    return postJson('/cfplan/plan/invalidate', params)
}

cfPlanApi.batchUpdateStatus = function (params) {
    return postJson('/cfplan/plan/batchUpdateStatus', params)
}

cfPlanApi.updatePlanByDetails = function (params) {
    return postJson('/cfplan/plan/updateByDetails', params)
}
